// extracted by mini-css-extract-plugin
export default {"wrapper":"Type_wrapper__qUM9V","icon":"Type_icon__oyn-a"};